export default "/_next/static/media/SourceSansProRegular.f2ff2fd6ab7cb4e0c469928c08461985.woff2";